// src/components/common/FullScreenMessage/FullScreenMessage.jsx
import React from 'react';
import styles from './FullScreenMessage.module.css';
import Button from '../Button/Button'; // Наш общий компонент кнопки

const FullScreenMessage = ({ icon, emoji, title, text, buttonProps, children }) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {icon && <div className={styles.iconWrapper}>{icon}</div>}
                {emoji && <div className={styles.emojiWrapper}>{emoji}</div>}
                {title && <h2 className={styles.title}>{title}</h2>}
                {text && <p className={styles.text}>{text}</p>}
                {children && <div className={styles.childrenContent}>{children}</div>}
                {buttonProps && buttonProps.text && (
                    <Button
                        onClick={buttonProps.onClick}
                        variant={buttonProps.variant || 'primary'}
                        className={`${styles.actionButton} ${buttonProps.className || ''}`}
                        {...buttonProps.additionalProps} // Для передачи disabled, etc.
                    >
                        {buttonProps.text}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default FullScreenMessage;
